import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from './../layout/layout.module';
import { CrisprCardComponent } from './crispr-card/crispr-card.component';
import { CrisprCartComponent } from './crispr-cart/crispr-cart.component';
import { CrisprListComponent } from './crispr-list/crispr-list.component';
import { CrisprSidebarComponent } from './crispr-sidebar/crispr-sidebar.component';
import { CrisprComponent } from './crispr.component';
import { CrisprQueryResolve } from './crispr.resolve';
import { CrisprCartItemComponent } from './crispr-cart-item/crispr-cart-item.component';

@NgModule({
  imports: [CommonModule, SharedModule, LayoutModule],
  declarations: [
    CrisprCardComponent,
    CrisprListComponent,
    CrisprSidebarComponent,
    CrisprComponent,
    CrisprCartComponent,
    CrisprCartItemComponent],
  providers: [CrisprQueryResolve]
})
export class CrisprModule {}
